import { render, staticRenderFns } from "./ModalTabelaPreco.vue?vue&type=template&id=8e2b5544&"
import script from "./ModalTabelaPreco.vue?vue&type=script&lang=js&"
export * from "./ModalTabelaPreco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports